// Single translation point between the API's content records and Kendo Scheduler's model fields.
// If backend column names change, this is the only file that needs updating.

const DEFAULT_DURATION_MS = 60 * 60 * 1000;

// Records created before the calendar existed have no endDate; fall back to a 1hr block.
const resolveEnd = (item, start) => {
  if (item.endDate) {
    const end = new Date(item.endDate);
    if (!isNaN(end.getTime()) && end > start) {
      return end;
    }
  }
  return new Date(start.getTime() + DEFAULT_DURATION_MS);
};

// Kendo needs exceptions as Date[]; the API carries them as a list of ISO strings.
const toExceptionDates = (value) => {
  if (!value) return null;
  const raw = Array.isArray(value) ? value : String(value).split(',');
  const dates = raw
    .map(v => (v instanceof Date ? v : new Date(String(v).trim())))
    .filter(d => !isNaN(d.getTime()));
  return dates.length ? dates : null;
};

const fromExceptionDates = (value) => {
  if (!value) return null;
  const raw = Array.isArray(value) ? value : [value];
  return raw.map(d => new Date(d).toISOString());
};

export const contentToEvent = (item) => {
  const start = new Date(item.date);

  return {
    ...item,
    start,
    end: resolveEnd(item, start),
    isAllDay: !!item.allDay,
    description: item.details || '',
    recurrenceRule: item.recurrenceRule || null,
    recurrenceId: item.recurrenceId || null,
    recurrenceExceptions: toExceptionDates(item.recurrenceExceptions),
  };
};

export const eventToContent = (event) => {
  const {
    start,
    end,
    isAllDay,
    description,
    Groups,
    expired, // server-computed, never written back
    ...rest
  } = event;

  return {
    ...rest,
    date: start,
    endDate: end,
    allDay: !!isAllDay,
    details: description || '',
    groups: Groups || rest.groups || [], // API returns `Groups`, accepts `groups`
    recurrenceExceptions: fromExceptionDates(rest.recurrenceExceptions),
  };
};
